import React from 'react';
import { PACKAGE_FEATURES } from '@src/constants/package';
import CheckOrCross from '../../Shared/CheckOrCross';

const vietnamesePremiumVoiceFeatures = ({ packages }) =>
  packages.map((pkg) => (
    <CheckOrCross
      key={pkg?.code}
      isCheck={pkg?.features?.includes(PACKAGE_FEATURES.PREMIUM_VIETNAM_VOICE)}
    />
  ));

export default vietnamesePremiumVoiceFeatures;
